<kendo-dialog
        *ngIf="opened"
        [title]="title"
        width="50%">
<div>
    <h3>Confirmations</h3>
    <kendo-grid
            (dataStateChange)="dataStateChange($event)"
            [data]="gridData"
            [kendoGridSelectBy]="'itemNumber'"
            [loading]="processRunning"
            [selectable]="{enabled: true, mode: 'multiple'}"
            [selectedKeys]="selection"

            style="height: 300px">
        <kendo-grid-column *ngFor="let col of columns" [field]="col.field" [filterable]="col.filterable"
                           [format]="col.format" [title]="col.title"

                           headerClass="HeaderGrid"></kendo-grid-column>
        <ng-template kendoGridNoRecordsTemplate>
            No Confirmations at this time.
        </ng-template>

    </kendo-grid>
    <div class="flexbutton">
        <div class="messageBox">
            <label>{{confirmationMessage}}</label>

        </div>
    </div>
</div>
    <kendo-dialog-actions>
        <app-mcl-button (buttonPressed)="close()"
                    text="Cancel"></app-mcl-button>
        <app-mcl-button (buttonPressed)="acknowledge(null)" [disabled]="isDisabled" [loading]="processRunning"
                       text="Acknowledge Order Changes"></app-mcl-button>
    </kendo-dialog-actions>
</kendo-dialog>
<div kendoDialogContainer></div>
